module.exports = __webpack_public_path__ + "img/16.1ae5e9d4.svg";